"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryDomainThirdLevelTemplate = void 0;
const lit_html_1 = require("lit-html");
const _button_1 = require("./_button");
/**
 * Возвращает шаблон основного домена 3го уровня в списке
 */
function getPrimaryDomainThirdLevelTemplate(domain, translations) {
    return (0, lit_html_1.html) `
        <div class="first-result__wrapper">
            <div class="domain domain--gray" data-id="${[domain.name, domain.zone].join('.')}" data-price="${domain.taken ? 0 : domain.price}">
                <div class="domain__wrapper">
                    <div class="domain__primary">
                        <div class="domain__name" href="/${translations.getLanguagePrefix()}/domain/${domain.name}">
                        <span>${domain.name}</span>.<span>${domain.zone}</span>
                    </div>
    
                        ${domain.premium ? (0, lit_html_1.html) `
                            <div class="domain__prefix">
                                <span class="domain__icon"></span>
                                ${translations.instant('premium')}
                            </div>                        
                        ` : null}
    
                        ${!domain.hideAvailability ? (0, lit_html_1.html) `
                            <div class="domain__availability">
                                <span class="text--sm">
                                    ${translations.instant('domainIsAvailable')}
                                </span>
                            </div>
                        ` : null}
                    </div>
                    
                    ${!domain.banned ? (0, lit_html_1.html) `
                        <div class="domain__tertiary">
                            <div class="domain__price-info">
                                ${domain.request ? (0, lit_html_1.html) `
                                    <div class="domain__price__request">${translations.instant('priceOnRequest')}</div>
                                ` : !domain.taken ? (0, lit_html_1.html) `
                                    <div class="domain__amount">
                                        <span class="text--sm">${translations.instant('domainPrice')}</span>
                                        <span class="text--lg">
                                        $${Intl.NumberFormat(undefined).format(domain.price)}
                                    </span>
                                    </div>
                                    <div class="domain__rent-time">
                                        <span class="text--sm">${translations.instant('renewalRate')}</span>
                                        <span class="text--lg">
                                        ${translations.instant('siteBuilderPlansFree')}
                                    </span>
                                    </div>
                                ` : null}
                            </div>

                            <div class="domain__actions">
                                ${(0, _button_1.getButtonTemplate)(domain, _button_1.ButtonTemplateStyle.BLACK, translations)}
                            </div>
                        </div>
                    ` : null}
                </div>
                <p class="domain__note">${translations.instant('thirdLevelSearchNote')}</p>
            </div>
            
            <div class="first-result__info">
                <div class="first-result__info-refund">
                    <span class="text--sm">${translations.instant('fiveDayMoneyBack')}</span>
                </div>
            </div>
        </div>
    `;
}
exports.getPrimaryDomainThirdLevelTemplate = getPrimaryDomainThirdLevelTemplate;
